// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b5540f2","503":"fdce3215","559":"396ca927","733":"ca257d33","880":"1d8a578d"}[chunkId] + ".chunk.js";
};